document.addEventListener('DOMContentLoaded', function() {
    // 1. TIMER LOGIC
    const timerDisplay = document.getElementById('puc-countdown');
    if (timerDisplay) {
        const targetDate = new Date(timerDisplay.dataset.date).getTime();

        const updateTimer = () => {
            const now = new Date().getTime();
            const diff = targetDate - now;

            if (diff <= 0) {
                timerDisplay.innerHTML = "CHALLENGE STARTED!";
                return;
            }

            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const secs = Math.floor((diff % (1000 * 60)) / 1000);

            timerDisplay.querySelector('.days').innerText = days.toString().padStart(2, '0');
            timerDisplay.querySelector('.hours').innerText = hours.toString().padStart(2, '0');
            timerDisplay.querySelector('.minutes').innerText = mins.toString().padStart(2, '0');
            timerDisplay.querySelector('.seconds').innerText = secs.toString().padStart(2, '0');
        };

        setInterval(updateTimer, 1000);
        updateTimer();
    }

    // 2. KLAVIYO FORM SUBMISSION
    const form = document.getElementById('puc-signup-form');
    if (form) {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            const btn = document.getElementById('puc-submit-btn');
            const res = document.getElementById('puc-form-response');
            
            const email = document.getElementById('puc-email').value;
            const name = document.getElementById('puc-name').value;
            const listId = form.dataset.listId;
            const companyId = form.dataset.companyId;

            btn.disabled = true;
            btn.innerText = "JOINING...";

            fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`, {
                method: 'POST',
                headers: { 'revision': '2024-02-15', 'content-type': 'application/json' },
                body: JSON.stringify({
                    data: {
                        type: 'subscription',
                        attributes: {
                            custom_source: 'Power Up Challenge 2026 Page',
                            profile: { data: { type: 'profile', attributes: { email: email, first_name: name } } }
                        },
                        relationships: { list: { data: { type: 'list', id: listId } } }
                    }
                })
            })
            .then(response => {
                if (response.ok) {
                    res.innerHTML = "SUCCESS! YOU'RE IN.";
                    res.style.color = "green";
                    form.reset();
                    btn.innerText = "JOINED!";
                } else {
                    throw new Error();
                }
            })
            .catch(() => {
                res.innerHTML = "Error joining. Try again.";
                res.style.color = "red";
                btn.disabled = false;
                btn.innerText = "TRY AGAIN";
            });
        });
    }
});